import React, { useState } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  Menu,
  Dropdown,
  Form,
  Input,
  Grid,
  message,
} from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import propertyImage from "../assets/property.png";
import CommonFooter from "../components/common/CommonFooter";
import { Link } from "react-router-dom";
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const ListPropertyPage = () => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedListedBy, setSelectedListedBy] = useState(""); // Add this state

  const menu = (
    <Menu
      theme="dark"
      style={{
        background: "rgba(0, 0, 0, 0.95)",
        color: "#fff",
        padding: "10px 25px",
        borderRadius: "6px",
      }}
      items={[
        {
          key: "0",
          label: (
            <Link to="/" style={{ color: "white" }}>
              Home
            </Link>
          ),
        },
        {
          key: "1",
          label: (
            <Link to="/about-us" style={{ color: "white" }}>
              Who we are
            </Link>
          ),
        },
        {
          key: "2",
          label: (
            <Link to="/listed-property" style={{ color: "white" }}>
              Our offerings
            </Link>
          ),
        },

        {
          key: "3",
          label: (
            <Link to="/work" style={{ color: "white" }}>
              How NITM works
            </Link>
          ),
        },
        {
          key: "4",
          label: (
            <Link to="/policy" style={{ color: "white" }}>
              List your Property
            </Link>
          ),
        },
        {
          key: "5",
          label: (
            <Link to="/news-room" style={{ color: "white" }}>
              News Room
            </Link>
          ),
        },
        {
          key: "6",
          label: (
            <Link to="/contact-us" style={{ color: "white" }}>
              Contact Us
            </Link>
          ),
        },
        {
          key: "7",
          label: (
            <Link to="/our-story" style={{ color: "white" }}>
              Our Story
            </Link>
          ),
        },
      ]}
    />
  );

  const onFinish = (values) => {
    // Store form values for navigation
    const userData = {
      name: values.name,
      email: values.email,
      mobile: values.mobile,
      whatsapp: values.whatsapp || "",
      listedBy: values.listedBy,
    };

    // Store in state or context if needed
    return userData;
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Please fill in all required fields correctly.");
  };

  // Update both form value and local state
  const handleListedByClick = (listedBy) => {
    setSelectedListedBy(listedBy);
    form.setFieldValue("listedBy", listedBy);
  };

  const handleListMyself = async () => {
    try {
      setLoading(true);
      // Validate all form fields
      const values = await form.validateFields();
      const userData = onFinish(values);

      // Navigate to ListPropertyFormPage with user data
      navigate("/form", { state: { userData } });
    } catch (error) {
      // Validation errors are automatically shown by Ant Design
      console.log("Validation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCallMe = async () => {
    try {
      setLoading(true);
      // Validate all form fields
      const values = await form.validateFields();
      const userData = onFinish(values);

      // Format WhatsApp message
      const whatsappMessage = `Hello! I would like to list my property on NotInTheMarket.com.

Here are my details:
📋 Name: ${userData.name}
📧 Email: ${userData.email}
📞 Mobile: ${userData.mobile}
${userData.whatsapp ? `📱 WhatsApp: ${userData.whatsapp}` : ""}
🏠 Listed By: ${userData.listedBy}

Please call me to discuss listing my property.`;

      // Encode the message for URL
      const encodedMessage = encodeURIComponent(whatsappMessage);

      // WhatsApp number (remove any spaces or special characters)
      const whatsappNumber = "923146007080".replace(/[^\d]/g, "");

      // Create WhatsApp URL
      const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

      // Open WhatsApp in new tab
      window.open(whatsappUrl, "_blank");

      // Show success message
      message.success("Opening WhatsApp to connect with our team!");

      // Optionally reset form after successful submission
      form.resetFields();
      setSelectedListedBy(""); // Reset the selection state
    } catch (error) {
      // Validation errors are automatically shown by Ant Design
      console.log("Validation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f0f0" }}>
      <Row style={{ minHeight: "100vh" }}>
        {/* Left Image Section */}
        {screens.md && (
          <Col md={12} style={{ position: "relative" }}>
            <img
              src={propertyImage}
              alt="Property"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: screens.xs ? "12px" : "0 0 140px 0",
              }}
            />
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{ position: "absolute", top: 20, left: 20, height: 40 }}
              />
            </Link>
          </Col>
        )}

        {/* Right Section */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#f0f0f0",
            minHeight: "100vh",
            position: "relative",
          }}
        >
          {/* Header */}
          <div
            style={{
              width: "100%",
              background: "#DDC7BB",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: 80,
            }}
          >
            <Title
              level={4}
              style={{ margin: "0 20px", color: "#000" }}
            ></Title>

            <Dropdown overlay={menu} placement="bottomRight">
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#D9D9D9E5",
                  padding: "0 20px",
                  cursor: "pointer",
                }}
              >
                {/* Custom Hamburger Icon */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    alignItems: "flex-end",
                  }}
                >
                  <span
                    style={{
                      width: "24px",
                      height: "3px",
                      background: "black",
                      borderRadius: "2px",
                    }}
                  ></span>
                  <span
                    style={{
                      width: "18px",
                      height: "3px",
                      background: "black",
                      borderRadius: "2px",
                    }}
                  ></span>
                  <span
                    style={{
                      width: "12px",
                      height: "3px",
                      background: "black",
                      borderRadius: "2px",
                    }}
                  ></span>
                </div>
              </div>
            </Dropdown>
          </div>

          {/* Form Card */}
          <div
            style={{
              maxWidth: 400,
              width: "100%",
              padding: "40px 40px",
              marginTop: 30,
              background: "#fff",
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginLeft: 20,
              marginRight: 20,
            }}
          >
            <Text>
              Thank you for choosing NotInTheMarket.com. We appreciate your
              trust in us. Please take a few moments to provide details about
              your property so we can list it accurately and connect you with
              genuine, qualified buyers.
            </Text>

            <Form
              form={form}
              layout="vertical"
              style={{ marginTop: 20 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              {/* Who is listing the property - REQUIRED */}
              <Form.Item
                name="listedBy"
                label={
                  <span style={{ fontWeight: "600" }}>
                    Who is listing the property?{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select who is listing the property",
                  },
                ]}
              >
                <Row gutter={8} style={{ marginBottom: 16, marginTop: 8 }}>
                  <Col span={12}>
                    <Button
                      block
                      onClick={() => handleListedByClick("Owner")}
                      style={{
                        color: selectedListedBy === "Owner" ? "#000" : "#000",
                        background:
                          selectedListedBy === "Owner" ? "#DDC7BB" : "#fff",
                        border:
                          selectedListedBy === "Owner"
                            ? "2px solid #DDC7BB"
                            : "1px solid #ccc",
                      }}
                    >
                      Owner
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      block
                      onClick={() => handleListedByClick("Appointed Agent")}
                      style={{
                        color:
                          selectedListedBy === "Appointed Agent"
                            ? "#000"
                            : "#000",
                        background:
                          selectedListedBy === "Appointed Agent"
                            ? "#DDC7BB"
                            : "#fff",
                        border:
                          selectedListedBy === "Appointed Agent"
                            ? "2px solid #DDC7BB"
                            : "1px solid #ccc",
                      }}
                    >
                      Appointed Agent
                    </Button>
                  </Col>
                </Row>
                <Row gutter={8} style={{ marginBottom: 16 }}>
                  <Col span={12}>
                    <Button
                      block
                      onClick={() => handleListedByClick("Private Office")}
                      style={{
                        color:
                          selectedListedBy === "Private Office"
                            ? "#000"
                            : "#000",
                        background:
                          selectedListedBy === "Private Office"
                            ? "#DDC7BB"
                            : "#fff",
                        border:
                          selectedListedBy === "Private Office"
                            ? "2px solid #DDC7BB"
                            : "1px solid #ccc",
                      }}
                    >
                      Private Office
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      block
                      onClick={() => handleListedByClick("Authorized Broker")}
                      style={{
                        color:
                          selectedListedBy === "Authorized Broker"
                            ? "#000"
                            : "#000",
                        background:
                          selectedListedBy === "Authorized Broker"
                            ? "#DDC7BB"
                            : "#fff",
                        border:
                          selectedListedBy === "Authorized Broker"
                            ? "2px solid #DDC7BB"
                            : "1px solid #ccc",
                      }}
                    >
                      Authorized Broker
                    </Button>
                  </Col>
                </Row>
              </Form.Item>

              {/* Name & Email Side by Side */}
              <Row gutter={8}>
                <Col span={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      { required: true, message: "Please enter your name" },
                      { min: 2, message: "Name must be at least 2 characters" },
                    ]}
                  >
                    <Input placeholder="Name" disabled={loading} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                  >
                    <Input placeholder="Email" disabled={loading} />
                  </Form.Item>
                </Col>
              </Row>

              {/* Mobile & WhatsApp Side by Side */}
              <Row gutter={8}>
                <Col span={12}>
                  <Form.Item
                    name="mobile"
                    label="Mobile"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your mobile number",
                      },
                      {
                        pattern: /^[+]?[\d\s\-()]+$/,
                        message: "Please enter a valid mobile number",
                      },
                    ]}
                  >
                    <Input placeholder="Mobile" disabled={loading} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="whatsapp"
                    label="WhatsApp"
                    rules={[
                      {
                        pattern: /^[+]?[\d\s\-()]*$/,
                        message: "Please enter a valid WhatsApp number",
                      },
                    ]}
                  >
                    <Input placeholder="WhatsApp" disabled={loading} />
                  </Form.Item>
                </Col>
              </Row>

              {/* Action Buttons */}
              <Row gutter={8}>
                <Col span={12}>
                  <Button
                    type="primary"
                    block
                    loading={loading}
                    onClick={handleCallMe}
                    style={{
                      background: "#000",
                      color: "#fff",
                      height: "40px",
                    }}
                  >
                    CALL ME TO LIST
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    block
                    loading={loading}
                    onClick={handleListMyself}
                    style={{
                      background: "#000",
                      color: "#fff",
                      height: "40px",
                    }}
                  >
                    I WILL LIST MYSELF
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
      <CommonFooter />
    </div>
  );
};

export default ListPropertyPage;
